// Single-sourced in @repeatmd/camera-core/react. Kept as a local re-export so
// existing stage imports and test mocks keep working. See docs/FRONTEND_TURBOREPO.md.
export { CameraLoadingSkeleton } from "@repeatmd/camera-core/react";
